import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#about", label: "Biography" },
  { href: "#ventures", label: "Ventures" },
  { href: "#digidoc", label: "DigiDoc" },
  { href: "#expertise", label: "Expertise" },
  { href: "#projects", label: "Projects" },
  { href: "#speaking", label: "Speaking" },
  { href: "#contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/75 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-sm bg-[#0A192F] text-white font-serif text-lg leading-none">
            SB
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-[#0A192F] text-base">Sean Bledsoe</span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#475569]">
              Executive Office
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="exec-link text-sm text-[#0A192F]/80 hover:text-[#0A192F] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta-book"
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 bg-[#0A192F] text-white text-sm rounded-full hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
        >
          Book a meeting
          <span aria-hidden>→</span>
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden p-2 text-[#0A192F]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-black/5"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-[#0A192F] text-lg font-serif"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-book"
              className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#0A192F] text-white rounded-full text-sm"
            >
              Book a meeting →
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
